import Vue from "vue";
import VueI18n from "vue-i18n";
import en_uk from "../langs/en_uk.json";
import en_us from "../langs/en_us.json";
import pt from "../langs/pt.json";
import de from "../langs/de.json";
import es from "../langs/es.json";
import fr from "../langs/fr.json";
import es_la from "../langs/es_la.json";

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: localStorage.getItem("lang") || "en_uk",
  messages: {
    en_uk,
    en_us,
    pt,
    de,
    es,
    es_la,
    fr
  }
});



// WEBPACK FOOTER //
// ./src/plugins/i18n.js